<template>
  <div class="normal-skeleton">
    <SkeletonAnimate class="skelete-1 skekete" />
    <SkeletonAnimate class="skelete-2 skekete mt-40" />
    <SkeletonAnimate class="skelete-3 skekete" />
    <SkeletonAnimate class="skelete-4 skekete" />
    <SkeletonAnimate class="skelete-3 skekete" />
  </div>
</template>
<script>
export default {
  name: "NormalSkeleton",
};
</script>
 <style lang="scss">
.normal-skeleton {
  width: 100%;
  .skekete {
    border-radius: 6px;
    margin-top: 20px;
    &.skelete-1 {
      height: 36px;
      width: 200px;
    }
    &.skelete-2 {
      height: 26px;
      width: 100px;
    }
    &.skelete-3 {
      height: 26px;
    }
    &.skelete-4 {
      height: 26px;
      width: 350px;
    }
  }
}
</style>